import React, { useCallback, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from '../ui/Logo';
import { ButtonLink } from '../ui/ButtonLink';
import { AboutDropdown } from './AboutDropdown';
import { MobileMenu } from './MobileMenu';
import { mainNav, QUOTE_PATH } from '../../data/site';
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const closeMobile = useCallback(() => setMobileOpen(false), []);
  useEffect(() => setMobileOpen(false), [location.pathname]);
  return <header className="sticky top-0 z-50 border-b border-white/10 bg-charcoal-950" data-id="element-292" data-mp="vs7bnb9a196t">
      <div className="mx-auto flex h-[96px] max-w-site items-center justify-between gap-4 px-5 md:px-8 lg:h-[136px]" data-id="element-293" data-mp="qyuwdrqhmeqq">
        <Logo sizeClass="h-[76px] lg:h-[120px]" data-id="element-294" data-mp="38qt5lh7oh09" />

        <nav aria-label="Main" className="hidden lg:block" data-id="element-295" data-mp="3uh64qiemlf0u">
          <ul className="flex items-center" data-id="element-296" data-mp="3uejyqn7dv7kq">
            {mainNav.map(item => <li key={item.label} data-id="element-297" data-mp="6v5dr2jmvj1e">
                {item.children ? <AboutDropdown item={item} data-id="element-298" data-mp="btq66fsn8yfa" /> : <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `relative block px-3 py-2 font-display text-[15px] font-semibold uppercase tracking-[0.08em] transition-colors duration-150 ${isActive ? 'text-white' : 'text-steel-200 hover:text-white'}`} data-id="element-299" data-mp="glqcqr37ypku">
                    {({
                isActive
              }) => <>
                        {item.label}
                        {isActive && <span className="absolute inset-x-3 -bottom-0.5 h-[3px] bg-brand-red" aria-hidden="true" data-id="element-300" data-mp="19affeujxb2yp" />}
                      </>}
                  </NavLink>}
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-301" data-mp="35daewh2fh20e">
          <ButtonLink to={QUOTE_PATH} size="sm" ariaLabel="Request a quote" data-id="element-302" data-mp="35cim1e07tidt">
            <span className="sm:hidden" data-id="element-303" data-mp="3jdbhc0ycchhz">Quote</span>
            <span className="hidden sm:inline" data-id="element-304" data-mp="3jap9e07jfzz8">Request a Quote</span>
          </ButtonLink>
          <button type="button" className="flex h-10 w-10 items-center justify-center text-white lg:hidden" aria-expanded={mobileOpen} aria-controls="mobile-menu" onClick={() => setMobileOpen(value => !value)} data-id="element-305" data-mp="3ebvtk14s3wvw">
            {mobileOpen ? <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-306" data-mp="30ga8g51o1x8r" /> : <MenuIcon className="h-6 w-6" aria-hidden="true" data-id="element-307" data-mp="2vn8pnlyc9djw" />}
            <span className="sr-only" data-id="element-308" data-mp="2vlnz07f5aerb">{mobileOpen ? 'Close menu' : 'Open menu'}</span>
          </button>
        </div>
      </div>
      <MobileMenu open={mobileOpen} onClose={closeMobile} data-id="element-309" data-mp="22zcy0vnmmbtz" />
    </header>;
}